// mirrors websocket/utils/group_utils.py's get_required_groups_for_checklist / user_meets_required_groups
export const getRequiredGroupsForChecklist = (
    thisChecklist: ObjectStringKeyAnyValue,
    allChecklistCategories: ObjectStringKeyAnyValue
): string[] => {
    const taggedValueIds: string[] = thisChecklist?.ChecklistCategories ?? []
    if (!taggedValueIds.length) return []

    const requiredGroupIds = new Set<string>()
    Object.values(allChecklistCategories ?? {}).forEach((category: any) => {
        Object.entries(category?.Values ?? {}).forEach(([valueId, value]: [string, any]) => {
            if (taggedValueIds.includes(valueId)) {
                (value?.RestrictAnsweringToGroups ?? []).forEach((groupId: string) => requiredGroupIds.add(groupId))
            }
        })
    })
    return Array.from(requiredGroupIds)
}

export const userMeetsRequiredGroups = (userGroupIds: string[] | null | undefined, requiredGroupIds: string[]): boolean => {
    if (!requiredGroupIds.length) return true
    const userGroupIdSet = new Set(userGroupIds ?? [])
    return requiredGroupIds.every((groupId) => userGroupIdSet.has(groupId))
}
